import { UserCreate } from './UserCreate'
import { UserEdit } from './UserEdit'
import { UserReservationList } from './UserB2ReservationList'
import { UserList } from './UserList'
import { UserShow } from './UserShow'

export {
  UserCreate as UserB2Create,
  UserEdit as UserB2Edit,
  UserReservationList as UserB2List,
  UserShow as UserB2Show,
  UserCreate,
  UserEdit,
  UserList,
  UserShow
}
